export default "__VITE_ASSET__C8sotR41__"